import { useMatch } from 'react-router';

export function useCurrentTeamId() {
	const match = useMatch('/teams/:teamId/*');
	return match?.params.teamId;
}
